import React, { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { CommonModal } from '../CommonModal';

import { PropertyHistorySection } from './PropertyHistorySection';
import { PropertyInfoSection } from './PropertyInfoSection';
import { PropertyTitleSection } from './PropertyTitleSection';

import { CommonModalType, ReturnComponentType } from 'common';
import { Paths } from 'enums';
import { useAppSelector, useTypedDispatch } from 'hooks';
import {
  deleteProperty,
  fetchCertainProperty,
  fetchProperties,
  PropertyType,
  selectCertainProperty,
  selectUserRole,
} from 'state';
import { setCertainProperty } from 'state/actions';
import { Button } from 'ui-kit';
import { checkIsAdmin, checkIsGoodStatus, checkIsManager } from 'utils';
import './ModalPropertyInfo.scss';
import { confirmAsync } from 'utils/confirmPopup';

type ModalPropertyInfoType = CommonModalType & {
  propertyId: string;
};

export const ModalPropertyInfo = ({
  showModal,
  setShowModal,
  propertyId,
}: ModalPropertyInfoType): ReturnComponentType => {
  const dispatch = useTypedDispatch();
  const navigate = useNavigate();
  const property = useAppSelector(selectCertainProperty);
  const role = useAppSelector(selectUserRole);
  const closePropertyInfoModal = () => {
    dispatch(setCertainProperty({} as PropertyType));
    setShowModal(false);
  };

  useEffect(() => {
    dispatch(fetchCertainProperty(propertyId));
  }, [dispatch]);

  const onManagePropertyClick = () => {
    navigate(`${Paths.MANAGEMENT}${Paths.PROPERTY}/${propertyId}`);
  };

  const onDeletePropertyClick = async () => {
    const response = await confirmAsync(
      'Are you sure you want to delete this property? THIS ACTION CANNOT BE UNDONE.',
    );

    if (!response) return;

    const status = await dispatch(deleteProperty(propertyId));

    if (checkIsGoodStatus(status)) {
      setShowModal(false);
      dispatch(fetchProperties(false));
    }
  };

  return (
    <CommonModal closeModal={closePropertyInfoModal} showModal={showModal}>
      <div className="ModalPropertyInfo">
        <header className="ModalPropertyInfo_Header">
          <div className="ModalPropertyInfo_Header_Title">Property Info</div>
          {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
          <div
            onClick={closePropertyInfoModal}
            className="ModalPropertyInfo_Header_Close"
          >
            &#10006;
          </div>
        </header>

        <div className="ModalPropertyInfo_Box">
          <PropertyTitleSection
            address={property?.address}
            isModal
            className="ModalPropertyInfo_Box_Title"
          />

          <div className="ModalPropertyInfo_Box_Community">
            {property?.community?.name}
          </div>

          <PropertyInfoSection
            property={property}
            className="ModalPropertyInfo_Box_Body"
          />

          <section className="ModalPropertyInfo_Box_Description">
            <h4>Description</h4>
            <div>{property?.description}</div>
          </section>

          <PropertyHistorySection propertyId={propertyId} />

          <section className="ModalPropertyInfo_Box_ButtonGroup">
            {(checkIsAdmin(role) || checkIsManager(role)) && (
              <Button onClick={onManagePropertyClick}>Manage</Button>
            )}
            {checkIsAdmin(role) && (
              <Button
                className="ModalPropertyInfo_Box_ButtonGroup_Button"
                onClick={onDeletePropertyClick}
              >
                Delete
              </Button>
            )}
          </section>
        </div>
      </div>
    </CommonModal>
  );
};
